module.exports = __webpack_public_path__ + "media/tips.5ba10e4b.mp3";